import React from "react";
const InputBoxes = (props) => {
  const { count, name, keyName, onTextChange, upperCase = true, marginCellNo=null, cssClassName="form-control text-center", set20PXWidth=false } = props;
  const style = upperCase ? {
    textTransform: "uppercase"
  } : {};
  const getStyle = (i) => {
    if( marginCellNo && marginCellNo.indexOf(i) >=0 ) {
      return upperCase ? {
        textTransform: "upperCase",
        marginRight: "10px"
      } : {
        marginRight: "10px"
      }
    } else if (set20PXWidth) {
      return upperCase ? {
        textTransform: "upperCase",
        width: "20px"
      } : {
        width: "20px"
      }
    }else {
      return style;
    }
  }
  return (
    <React.Fragment>
      {[...Array(count).keys()].map((i) => (
        <input key={`${keyName}${(i + 1)}`} maxLength="1" type="text" id={`${keyName}${(i + 1)}`} name={`${keyName}${(i + 1)}`} className={cssClassName} value={name[`${i}`]} onChange={onTextChange} style={getStyle(i)} />
      ))}
    </React.Fragment>
  );
};

export default InputBoxes;